import { render } from "./MfittBookingConfirmation.vue?vue&type=template&id=9071e72e"
import script from "./MfittBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./MfittBookingConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script